module.exports = __webpack_public_path__ + "img/header_logo.eec7cd3d.svg";